import React from 'react';
import { motion } from 'framer-motion';
import AnimatedSection from './AnimatedSection';
import { useTranslation } from "react-i18next";
import "../i18n";


const IndustriesSection = () => {
  const { t } = useTranslation(['industriesHome']);
  
    return (
        <section 
            id="industries-preview" 
            className="relative lg:min-h-[800px] overflow-hidden py-4 sm:py-4 md:py-16 lg:py-16 px-2"
        >
            {/* Background Image Container */}
            <div 
                className="absolute inset-0 w-full h-full"
                style={{
                    backgroundImage: 'url("/images/others/IndustriesBack.svg")',
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    WebkitMaskImage: `
                        linear-gradient(to right, 
                            transparent, 
                            black 20%, 
                            black 80%, 
                            transparent
                        ),
                        linear-gradient(to bottom, 
                            transparent, 
                            black 20%, 
                            black 80%, 
                            transparent
                        )
                    `,
                    maskImage: `
                        linear-gradient(to right, 
                            transparent, 
                            black 20%, 
                            black 80%, 
                            transparent
                        ),
                        linear-gradient(to bottom, 
                            transparent, 
                            black 20%, 
                            black 80%, 
                            transparent
                        )
                    `,
                    WebkitMaskComposite: 'intersect',
                    maskComposite: 'intersect',
                    zIndex: 0
                }}
            />
            
            <AnimatedSection>
                {/* Grid container with reduced gap */}
                <div className="grid grid-cols-12 grid-rows-1 gap-4 lg:min-h-[600px] relative z-10">
                    {/* Title and Description - moved closer */}
                    <div className="col-span-12 row-start-1 flex flex-col justify-center items-center space-y-8">
                        <motion.h2
                            className="text-5xl lg:text-8xl font-bold text-center">
                            {t("industriesHome:industries.title")}
                        </motion.h2>
                        
                        <motion.p 
                            className="text-xl lg:text-3xl max-w-4xl text-center leading-relaxed"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3 }}
                        >
                            {t("industriesHome:industries.description")}
                        </motion.p>
                    </div>

                    {/* Button - moved up */}
                    <div className="col-span-12 row-start-3 flex justify-center items-center">
                        <motion.div>
                            <a 
                                href="/industries"
                                className="text-white inline-block bg-orange-500 hover:bg-orange-600 px-8 py-3 rounded-lg transition duration-300"
                            >
                                {t("industriesHome:button.title")}
                            </a>
                        </motion.div>
                    </div>
                </div>
            </AnimatedSection>
        </section>
    );
};

export default IndustriesSection;